import React, { useEffect } from "react";
import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";
import PiLoadingBackdrop from "./components/PiLoadingBackdrop";
import Editor from "./features/routing/Editor";
import "./style.css";
import useInteractionFactoryImports from "./hooks/InteractionFactoryImports.hook";

import {
  PlayItAuthenticationPage,
  Roles,
  UsePlayItAuthentication,
} from "@playit/shared-authentication";
import { useLogin } from "./features/authentication/LoginHooks";
import { CircularProgress } from "@mui/material";
import { AuthenticationService } from "./services/AuthenticationService";
import useValidationRoot from "./features/validation/ValidationRoot.hook";
import { EDITOR_LANGUAGE_STORAGE_KEY } from "./features/i18n/languages";

function Creator() {
  //const isAuthenticated = useSelector(selectAuthenticated);
  const { t, i18n } = useTranslation();
  const {} = useInteractionFactoryImports();
  const { onLoginSuccessful, isOrganizationsLoading } = useLogin();
  const _ = useValidationRoot(); // validate when initializing the training
  // language
  useEffect(() => {
    const editorLang = localStorage.getItem(EDITOR_LANGUAGE_STORAGE_KEY);
    if (editorLang) {
      i18n.changeLanguage(editorLang);
    }
  }, []);

  // setup auth package
  const endpoint = process.env.REACT_APP_PLAYIT_MAINAPI ?? "";
  const endpointCreator = process.env.REACT_APP_PLAYIT_CREATORAPI ?? "";
  const {
    isAuthenticated,
    authData,
    isLoading: isAuthenticating,
    logout,
    errorMessage,
  } = UsePlayItAuthentication(
    Roles.Creator,
    endpoint,
    endpointCreator,
    onLoginSuccessful
  );

  useEffect(() => {
    AuthenticationService.SetOnLogout(logout);
  }, [logout]);

  const view = isAuthenticated ? (
    <Editor />
  ) : (
    <div className="w-screen h-screen">
      <PlayItAuthenticationPage
        authData={authData}
        errorMessage={errorMessage}
      />
    </div>
  );

  const body =
    isAuthenticating || isOrganizationsLoading ? (
      <div className="w-screen h-screen">
        <div className="flex justify-center items-center h-full">
          <CircularProgress size="150px" />
        </div>
      </div>
    ) : (
      view
    );
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Play It Creator</title>
        <meta
          name="description"
          content="somebody should write a description for the Play It Creator"
        />
      </Helmet>
      {body}
      <PiLoadingBackdrop />
    </>
  );
}

export default Creator;
